// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"5f296149","796":"3b3af050"}[chunkId] + ".chunk.js";
};